// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__21LXz","bigColWidth":"Table_bigColWidth__U978u","biggerColWidth":"Table_biggerColWidth__hSR-Y","row":"Table_row__2pj1N","col":"Table_col__3lnrG"};